import React from 'react';

import PropTypes from 'prop-types';
import withStyles from '@material-ui/core/styles/withStyles';
import { Tooltip, Typography } from '@material-ui/core';

import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined';
import HomeIcon from '@material-ui/icons/Home';
import InfoCard from '../../common/InfoCard';
import InfoCardList from '../../common/InfoCardList';
import Title from '../../Title';

import { compose } from 'redux';
import { connect } from 'react-redux';

import LaunchIcon from '@material-ui/icons/Launch';
import AuthorityCard from './AuthorityCard';

class SiteAreaInformation extends React.Component {
    static propTypes = {
        classes: PropTypes.object.isRequired,
        // Redux State
        areaInfo: PropTypes.object
    };

    constructor (props) {
        super(props);
    }

    render () {
        const { classes, areaInfo } = this.props;

        const isLoading = !Boolean(areaInfo);

        return (

            <>
                <Title
                    title="AREA INFORMATION"
                    skeleton={isLoading}
                />
                <AuthorityCard areaInfo={areaInfo} />
                <InfoCardList>
                    <InfoCard skeleton={isLoading}>
                        <Typography>
                            Population
                            <Tooltip arrow title={'Population of the lower super output area'} placement={'right'}>
                                <InfoOutlinedIcon />
                            </Tooltip>
                        </Typography>
                        <Typography>
                            <HomeIcon /> {/* replace */}
                            {(!isLoading && areaInfo.lsoaPopulation) ? `${areaInfo.lsoaPopulation.toLocaleString()}` : 'N/A'}
                        </Typography>
                    </InfoCard>
                    <InfoCard skeleton={isLoading}>
                        <Typography>
                            IMD Score
                            <Tooltip arrow title={'IMD Score (1 least deprived - 10 most deprived) for the lower super output area'} placement={'right'}>
                                <InfoOutlinedIcon />
                            </Tooltip>
                        </Typography>
                        <Typography>
                            <HomeIcon /> {/* replace */}
                            {(!isLoading && areaInfo.lsoaImd) ? `${areaInfo.lsoaImd}/10` : 'N/A'}
                        </Typography>
                    </InfoCard>
                </InfoCardList>
            </>
        );
    }
}

const style = theme => ({

});

const mapStateToProps = (state) => {
    const currentPolygon = state.parcelPanel.currentPolygonId && state.parcelPanel.polygons[state.parcelPanel.currentPolygonId];
    return {
        areaInfo: currentPolygon && currentPolygon.areaInfo
    };
};

const mapDispatchToProps = (dispatch) => ({

});

export default compose(
    connect(mapStateToProps, mapDispatchToProps),
    withStyles(style)
)(SiteAreaInformation);